export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      tenants: [
        {
          tenant: {
            tenantUuid: "tenants002",
            name: "アイラ株式会社",
            nameKana: "アイラカブシキカイシャ",
            address: "東京都千代田区",
            sectionName: "地域サポート部門",
            staffName: "どい",
            tel: "03-3333-3333",
            email: "bbb@bbb.com",
            note: "note",
            status: 1,
            createdAt: 1594880785395,
            updatedAt: 1594880785395
          },
          communityCount: 2
        },
        {
          tenant: {
            tenantUuid: "tenants001",
            name: "〇〇株式会社",
            nameKana: "マルマルカブシキカイシャ",
            address: "東京都新宿区",
            sectionName: "地域活性課",
            staffName: "相良　太郎",
            tel: "03-0000-0000",
            email: "aaa@aaa.com",
            note: "note test",
            status: 1,
            createdAt: 1594880785395,
            updatedAt: 1594880785395
          },
          communityCount: 1
        }
      ]
    }
  }
}